import script from "./IframeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeModal.vue?vue&type=script&setup=true&lang=js"

import "./IframeModal.vue?vue&type=style&index=0&id=2ea07c80&lang=css"

const __exports__ = script;

export default __exports__